<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Position.ObjectName")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="positionKeyword"
              @text="KeyWord = $event"
              :label="$t('Position.ObjectName')"
            />
          </v-row>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="positionItems"
        :loading="loading"
        :search="filter"
        multi-sort
        class="elevation-0 px-6"
        fixed-header
        height="360px"
        v-resize="resizeHeader"
        :footer-props="footerProps"
      >
        <template v-slot:header.check>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              stock_positions.find((detail) => detail.check != checkAll)
                ? true
                : false
            "
            v-model="checkAll"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("Role.TemplatePermissionFields.check_all") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.check="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.check"
              :true-value="1"
              :false-value="0"
              :disabled="item.disabled"
            >
            </v-checkbox>
          </div>
        </template>
      </v-data-table>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="accent"
          @click="
            $emit(
              'confirm',
              stock_positions.filter((d) => d.check)
            );
            dialog = false;
          "
        >
          {{
            $t("CRUD.confirmWithChooseCount", [
              stock_positions && stock_positions.length
                ? stock_positions.filter((s) => s.check).length
                : 0,
            ])
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import stockPosition from "@/api/stock_position";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

export default {
  name: "DialogPositions",

  components: { SearcherKeyword },

  props: {
    value: Boolean,
    positionSelected: Array,
    disabled: Array,
    stockId: Number,
    existMaterial: Number, //盘点筛选新商品
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Position.Fields.stock_position_code"),
          align: "start",
          sortable: false,
          value: "position_code",
        },
        {
          text: i18n.t("Position.Fields.stock_position_name"),
          align: "start",
          sortable: false,
          value: "position_name",
        },
        {
          text: i18n.t("Role.DistrictPermissionFields.check_all"),
          align: "start",
          sortable: false,
          value: "check",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },
    positionItems() {
      //前端搜索
      return this.stock_positions.filter(
        (item) =>
          (this.positionKeyword &&
            (item.position_name.indexOf(this.positionKeyword) > -1 ||
              item.position_code.indexOf(this.positionKeyword) > -1)) ||
          !this.positionKeyword
      );
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    filter: "",
    itemsPerPageOptions: 10,
    checkAll: 0,
    stock_positions: [],
    positionKeyword: "",
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          // 每次打开对话框重置查询
          this.getStockPositionFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.filter = "";
        }
      },
    },
    checkAll: {
      handler() {
        this.stock_positions = this.stock_positions.map(
          function (detail) {
            detail.check = this.checkAll ? 1 : 0;
            return detail;
          }.bind(this)
        );
      },
    },
  },

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },

    getStockPositionFromAPI() {
      this.Loading = true;
      var data = {};
      if (this.existMaterial) {
        data = Object.assign(data, { exist_material: this.existMaterial });
      }
      if (this.stockId) {
        data = Object.assign(data, { stock_id: this.stockId });
      }
      stockPosition
        .fetchAllForSelect(data)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stock_positions = response.data.stock_positions.map(
                (item) => {
                  if (this.positionSelected) {
                    this.positionSelected.forEach((selected) => {
                      if (selected.id == item.id) {
                        item.check = 1;
                        item.disabled = true;
                      }
                    });
                  }
                  if (this.disabled) {
                    this.disabled.forEach((d) => {
                      if (d == item.id) {
                        item.disabled = true;
                      }
                    });
                  }

                  return item;
                }
              );
            }
            this.Loading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.Loading = false;
          }.bind(this)
        );
    },
  },
};
</script>
